import React, { FC, Fragment, useState } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import { CSSTransition } from 'react-transition-group';
import FrChatDotsSvg from '@src/svgs/fr-chat-dots-grey.svg';
import { MessageSenderEnum } from '@src/graphql/generated';
import { Message } from './Message';
import { MessagesProps } from './props';
import './styles.scss';

export const Messages: FC<MessagesProps> = ({ className, messages, user, openingTitle }) => {
  const [selectedMessageId, setSelectedMessageId] = useState<string>();

  return (
    <Fragment>
      <CSSTransition classNames="message" in={!!messages.length} timeout={150}>
        <div className={classnames('fr-messages', className)}>
          {!messages.length ? (
            <div className="fr-messages__empty">
              <Svg className="fr-messages__icon" src={FrChatDotsSvg} />

              <div className="fr-messages__empty-text">
                This is the beginning of your message history with {user.name}
              </div>
            </div>
          ) : (
            messages.map((message, i) => {
              if (!message) {
                return null;
              }

              // calculate if message is last in list from sender
              // or is from different recruiters
              const nextMessage = messages[i + 1];
              let isLastMessage = !nextMessage || message?.sender !== nextMessage.sender;
              const isSelected = message.id === selectedMessageId;

              if (
                nextMessage &&
                message?.sender === MessageSenderEnum.RECRUITER &&
                nextMessage.sender === MessageSenderEnum.RECRUITER
              ) {
                isLastMessage = message.recruiter?.id !== nextMessage.recruiter?.id;
              }

              return (
                <Message
                  isLastMessage={isLastMessage}
                  isSelected={isSelected}
                  key={message.id}
                  message={message}
                  onClick={() => setSelectedMessageId(isSelected ? undefined : message.id)}
                  openingTitle={openingTitle}
                  user={user}
                />
              );
            })
          )}
        </div>
      </CSSTransition>
    </Fragment>
  );
};
